import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as bootstrap from 'bootstrap';

import { FaEdit } from 'react-icons/fa';
import '../../../assets/css/companysetting/Settings.css';
const API_BASE_URL = process.env.REACT_APP_API_URL;

const API_BASE = `${API_BASE_URL}/api/settings`;

function Settings() {
  const [settings, setSettings] = useState([]);
  const [formData, setFormData] = useState({
    companyName: '',
    address: '',
    website: '',
    description: '',
    remark: '',
    email: '',
    contactNumber: ''
  });
  const [companyLogo, setCompanyLogo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');

  const userPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const canEdit = userPermissions.includes("update_CompanySettings");

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(API_BASE);
      const data = Array.isArray(res.data) ? res.data : [res.data];
      const filtered = data.filter(item => item && item.companyName);
      setSettings(filtered);

      if (filtered.length > 0) {
        const setting = filtered[0];
        setFormData({
          companyName: setting.companyName || '',
          address: setting.address || '',
          website: setting.website || '',
          description: setting.description || '',
          remark: setting.remark || '',
          email: setting.email || '',
          contactNumber: setting.contactNumber || ''
        });
        setPreview(setting.companyLogo ? `${API_BASE_URL}/uploads/${setting.companyLogo}` : null);
        setCompanyLogo(null);
      }

      setError('');
    } catch (err) {
      console.error('Fetch error:', err);
      setError('Failed to fetch settings from the server.');
    }
  };

  const handleEditClick = () => {
    const modal = new bootstrap.Modal(document.getElementById('settingModal'));
    modal.show();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (settings.length === 0) {
      setError('No settings found to update.');
      return;
    }

    const payload = new FormData();
    for (const key in formData) {
      payload.append(key, formData[key]);
    }
    if (companyLogo) {
      payload.append('companyLogo', companyLogo);
    }

    try {
      const id = settings[0]._id;
      await axios.put(`${API_BASE}/${id}`, payload);
      fetchSettings();

      const modal = bootstrap.Modal.getInstance(document.getElementById('settingModal'));
      modal.hide();
      setError('');
    } catch (err) {
      console.error('Submit error:', err);
      setError('Failed to save settings. Please try again.');
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 style={{ color: '#102234', fontWeight: 'bold' }}>Company Settings</h4>
        {canEdit && (
          <button
            className="btn btn-outline-primary d-flex align-items-center gap-1"
            onClick={handleEditClick}
            title="Edit Settings"
            aria-label="Edit Settings"
          >
            <FaEdit />
            Edit
          </button>
        )}
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {settings.length > 0 ? (
        <div className="card shadow-box">
          <div className="card-header company-details-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Company Details</h5>
            <div className="header-right d-flex align-items-center">
              <span className="company-name" title={settings[0].companyName}>
                {settings[0].companyName}
              </span>
            </div>
          </div>

          <div className="card-body shadow-box">
            <h6 style={{ fontWeight: 'bold' }}>General Details</h6>
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td><strong>Name:</strong></td>
                    <td>{settings[0].companyName}</td>
                    <td><strong>Website:</strong></td>
                    <td>{settings[0].website}</td>
                  </tr>
                  <tr>
                    <td><strong>Address:</strong></td>
                    <td>{settings[0].address}</td>
                    <td><strong>Description:</strong></td>
                    <td>{settings[0].description}</td>
                  </tr>
                  <tr>
                    <td><strong>Remarks:</strong></td>
                    <td>{settings[0].remark}</td>
                    <td><strong>Email:</strong></td>
                    <td>{settings[0].email}</td>
                  </tr>
                  <tr>
                    <td><strong>Contact Number:</strong></td>
                    <td>{settings[0].contactNumber}</td>
                    <td><strong>Logo:</strong></td>
                    <td>
                      {settings[0].companyLogo && (
                        <img
                          src={`${API_BASE_URL}/uploads/${settings[0].companyLogo}`}
                          alt="Company Logo"
                          height="60"
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <p>No company settings found.</p>
      )}

      {/* Modal */}
      <div className="modal fade" id="settingModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <form className="modal-content shadow-box" onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Company Settings</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row g-3">
                {[
                  { label: 'Name', key: 'companyName' },
                  { label: 'Website', key: 'website' },
                  { label: 'Address', key: 'address' },
                  { label: 'Description', key: 'description' },
                  { label: 'Remarks', key: 'remark' },
                  { label: 'Contact Number', key: 'contactNumber' },
                  { label: 'Email Address', key: 'email' }
                ].map(({ label, key }) => (
                  <div className="col-md-6" key={key}>
                    <label className="form-label">{label}</label>
                    <input
                      type="text"
                      className="form-control"
                      name={key}
                      value={formData[key]}
                      onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
                      disabled={!canEdit}
                      required
                    />
                  </div>
                ))}

                <div className="col-12">
                  <label className="form-label">Company Logo</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setCompanyLogo(e.target.files[0]);
                        setPreview(URL.createObjectURL(e.target.files[0]));
                      }
                    }}
                    disabled={!canEdit}
                  />
                  {preview && (
                    <div className="mt-2">
                      <img src={preview} alt="Preview" height="80" />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-success" disabled={!canEdit}>
                Save Changes
              </button>
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Settings;
